"use client";

import { logError } from "@red-digital/bricks";
import { useEffect } from "react";

export const LogPageNotFound = () => {
  useEffect(() => {
    logError(`404 – Page not found`);
  }, []);

  return null;
};
